module.exports = {"male":"männlich","female":"weiblich"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/people/de.json
// module id = 547
// module chunks = 1